import { useState, useEffect } from 'react';
import axios from 'axios';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';
import { Table, Space, Button, Divider, PageHeader, message, Tag, Row, Col, Statistic, Card } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import VehicleAdd from './VehicleAdd';
import VehicleUpdate from './VehicleUpdate';
import moment from 'moment';

function Vehicle() {

    const [vehicleData, setVehicleData] = useState()
    const [makeData, setMakeData] = useState()
    const [modelData, setModelData] = useState()

    const fetchVehicles = () => {
        let aipURL = `${FetchVariable.Heroku}/vehicle/`
        axios.get(aipURL)
            .then((res) => {
                let data = res.data
                setVehicleData(data)
            })

        fetch(`${FetchVariable.Heroku}/vehicle/vehicle-for-sale`)
            .then((response) => response.json())
            .then((json) => {
                setVForSale(json[0].NumVehicleForSale)
            })
            .catch((error) => {
                console.log('fetch data failed', error);
            })

        fetch(`${FetchVariable.Heroku}/vehicle/vehicle-for-repair`)
            .then((response) => response.json())
            .then((json) => {
                setVForRepair(json[0].NumVehicleForRepair)
            })
            .catch((error) => {
                console.log('fetch data failed', error);
            });

        fetch(`${FetchVariable.Heroku}/vehicle/vehicle-for-arriving`)
            .then((response) => response.json())
            .then((json) => {
                setVForArriving(json[0].NumVehicleForArriving)
            })
            .catch((error) => {
                console.log('fetch data failed', error);
            })

        fetch(`${FetchVariable.Heroku}/vehicle/vehicle-in-good-con`)
            .then((response) => response.json())
            .then((json) => {
                setVInGood(json[0].NumVehicleInGoodCond)
            })
            .catch((error) => {
                console.log('fetch data failed', error);
            });

        fetch(`${FetchVariable.Heroku}/vehicle/vehicle-in-fair-con`)
            .then((response) => response.json())
            .then((json) => {
                setVInFair(json[0].NumVehicleInFairCond)
            })
            .catch((error) => {
                console.log('fetch data failed', error);
            });

        fetch(`${FetchVariable.Heroku}/vehicle/vehicle-in-poor-con`)
            .then((response) => response.json())
            .then((json) => {
                setVInPoor(json[0].NumVehicleInPoorCond)
            })
            .catch((error) => {
                console.log('fetch data failed', error);
            });
    }

    const addVehicle = (addVehicleData) => {
        addVehicleData.PurchaseDate = moment(addVehicleData.PurchaseDate).format("YYYY-MM-DD")
        let apiURL = `${FetchVariable.Heroku}/vehicle/`
        axios.post(apiURL, addVehicleData)
            .then(res => {
                if (res.data.error) {
                    let errorMessage = (res.data.error).split(" ", 3).join(" ", 3)
                    message.error(errorMessage, 10);
                }
                else {
                    fetchVehicles()
                }
            })
            .catch(err => { console.log(err) })
    }

    const deleteVehicle = (deleteID) => {
        let apiURL = `${FetchVariable.Heroku}/vehicle/` + deleteID
        axios.delete(apiURL)
            .then(() => {
                fetchVehicles()
                message.error('The Vehicle is deleted')
            })
    }

    const updateVehicle = (updateVehicle) => {
        let apiURL = `${FetchVariable.Heroku}/vehicle/`
        axios.put(apiURL, updateVehicle)
            .then(() => {
                fetchVehicles()
                message.success('Vehicle Updated!')
            }).catch(err => { console.log(err) })
    }

    useEffect(() => {
        fetchVehicles();
    }, [])

    useEffect(() => {
        let makeURL = `${FetchVariable.Heroku}/make/`
        axios.get(makeURL)
            .then((res) => {
                let data = res.data
                setMakeData(data)
            })
    }, [])

    useEffect(() => {
        let modelURL = `${FetchVariable.Heroku}/model/`
        axios.get(modelURL)
            .then((res) => {
                let data = res.data
                setModelData(data)
            })
    }, [])

    const [vForSale, setVForSale] = useState()
    const [vForRepair, setVForRepair] = useState()
    const [vForArriving, setVForArriving] = useState()
    const [vInGood, setVInGood] = useState()
    const [vInFair, setVInFair] = useState()
    const [vInPoor, setVInPoor] = useState()

    let makeFilter = []
    makeData?.forEach((e) => { makeFilter.push({ text: e.Make, value: e.Make }) })
    let modelFilter = []
    modelData?.forEach((e) => { modelFilter.push({ text: e.Model, value: e.Model }) })
    let vinFilter = []
    vehicleData?.forEach((e) => { vinFilter.push({ text: e.VehicleVIN, value: e.VehicleVIN }) })

    const VehicleColums = [
        {
            title: 'ID',
            width: 100,
            dataIndex: 'VehicleID',
            key: 'VehicleID',
            fixed: 'left',
            sorter: (a, b) => a.VehicleID - b.VehicleID,
            sortDirections: ['descend', 'ascend'],
            defaultSortOrder: 'descend',
        },
        {
            title: 'VIN',
            dataIndex: 'VehicleVIN',
            key: 'VehicleVIN',
            width: 100,
            filters: vinFilter,
            filterSearch: true,
            onFilter: (value, record) => record.VehicleVIN.indexOf(value) === 0,
        },
        {
            title: 'Model',
            dataIndex: 'Model',
            key: 'Model',
            width: 100,
            filters: modelFilter,
            filterSearch: true,
            onFilter: (value, record) => record.Model.indexOf(value) === 0,
        },
        {
            title: 'Make',
            dataIndex: 'MakeIcon',
            key: 'MakeIcon',
            width: 100,
            filters: makeFilter,
            filterSearch: true,
            onFilter: (value, record) => record.Make.indexOf(value) === 0,
            render: (record, value) => {
                if (value.Make === null) {
                    return (
                        <p style={{ marginBottom: 'auto', marginTop: 'auto', marginLeft: '7px' }}>N/A</p>
                    )
                } else {
                    return (
                        <img src={`https://img.icons8.com/color/48/000000/${value.Make.toLowerCase()}.png`} alt={value.Make} />
                    )
                }
            }
        },
        {
            title: 'Status',
            dataIndex: 'VehicleStatus',
            key: 'VehicleStatus',
            width: 100,
            filters: [
                { text: 'ForSale', value: 'ForSale' },
                { text: 'Repair', value: 'Repair' },
                { text: 'Arriving', value: 'Arriving' },
                { text: 'Sold', value: 'Sold' },
                { text: 'Null', value: '' },
            ],
            filterSearch: true,
            onFilter: (value, record) => record.VehicleStatus.indexOf(value) === 0,
            render: (record) => {
                if (record === 'ForSale') { return (<Tag color="success">ForSale</Tag>) }
                else if (record === 'Repair') { return (<Tag color="warning"> Repair</Tag>) }
                else if (record === 'Arriving') { return (<Tag color="processing"> Arriving</Tag>) }
                else if (record === 'Sold') { return (<Tag color="purple">Sold</Tag>) }
                else { return (<Tag color="default">Waiting</Tag>) }
            },
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: 'Color',
            dataIndex: 'VehicleColor',
            key: 'VehicleColor',
            filters: [
                { text: 'Yellow', value: 'Yellow' },
                { text: 'White', value: 'White' },
                { text: 'Red', value: 'Red' },
                { text: 'Green', value: 'Green' },
                { text: 'Gray', value: 'Gray' },
                { text: 'Blue', value: 'Blue' },
                { text: 'Brown', value: 'Brown' },
                { text: 'Black', value: 'Black' },
            ],
            width: 100,
            filterSearch: true,
            onFilter: (value, record) => record.VehicleColor.indexOf(value) === 0,
            sorter: (a, b) => a.VehicleColor.length - b.VehicleColor.length,
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: 'MPG',
            dataIndex: 'VehicleMPG',
            key: 'VehicleMPG',
            defaultSortOrder: 'descend',
            sorter: (a, b) => a.VehicleMPG - b.VehicleMPG,
            width: 100,
        },

        {
            title: 'Miles',
            dataIndex: 'VehicleMiles',
            key: 'VehicleMiles',
            sorter: (a, b) => a.VehicleMiles - b.VehicleMiles,
            sortDirections: ['descend', 'ascend'],
            width: 150,
        },
        {
            title: 'Year',
            dataIndex: 'VehicleYear',
            key: 'VehicleYear',
            sorter: (a, b) => a.VehicleYear - b.VehicleYear,
            sortDirections: ['descend', 'ascend'],
            width: 100,
        },
        {
            title: 'Condition',
            dataIndex: 'VehicleCondition',
            key: 'VehicleCondition',
            filters: [
                { text: 'Good', value: 'Good' },
                { text: 'Fair', value: 'Fair' },
                { text: 'Poor', value: 'Poor' },
            ],
            onFilter: (value, record) => record.VehicleCondition.indexOf(value) === 0,
            sorter: (a, b) => a.VehicleCondition.length - b.VehicleCondition.length,
            sortDirections: ['descend', 'ascend'],
            width: 125,
            render: (record) => {
                if (record === 'Good') { return (<Tag color="success">Good</Tag>) }
                else if (record === 'Fair') { return (<Tag color="warning"> Fair</Tag>) }
                else if (record === 'Poor') { return (<Tag color="error"> Poor</Tag>) }
                else { return (<Tag color="default"></Tag>) }
            },
        },
        {
            title: 'P-Price',
            dataIndex: 'PurchasePrice',
            key: 'PurchasePrice',
            sorter: (a, b) => a.PurchasePrice - b.PurchasePrice,
            sortDirections: ['descend', 'ascend'],
            width: 100,
        },
        {
            title: 'S-Price',
            dataIndex: 'SalesPrice',
            key: 'SalesPrice',
            sorter: (a, b) => a.SalesPrice - b.SalesPrice,
            sortDirections: ['descend', 'ascend'],
            width: 100,

        },
        {
            title: 'PurchaseDate',
            dataIndex: 'PurchaseDate',
            key: 'PurchaseDate',
            width: 150,
        },
        {
            title: 'Action',
            key: 'action',
            fixed: 'right',
            width: 100,
            render: (record) => (
                <Space size="middle">
                    <VehicleUpdate record={record} updateVehicle={updateVehicle} />
                    <Button onClick={() => deleteVehicle(record.VehicleID)} type="primary" danger icon={<DeleteOutlined />}></Button>
                </Space>
            ),
        },
    ]

    return (
        <>
            <PageHeader
                className="site-page-header"
                title="Vehicle Management"
                extra={[
                    <VehicleAdd key='addVehicle' addVehicle={addVehicle} />
                ]}
            >
                <Row gutter={[32, 32]}>
                    <Col span={8}>
                        <Card>
                            <Statistic
                                title="Vehicle For Sale"
                                value={vForSale}
                            />
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card>
                            <Statistic
                                title="Vehicle For Repair"
                                value={vForRepair}
                            />
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card>
                            <Statistic
                                title="Vehicle For Arriving"
                                value={vForArriving}
                            />
                        </Card>
                    </Col>

                    <Col span={8}>
                        <Card>
                            <Statistic
                                title="Vehicle In Good Condition"
                                value={vInGood}
                                valueStyle={{ color: '#28a745' }}
                            />
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card>
                            <Statistic
                                title="Vehicle In Fair Condition"
                                value={vInFair}
                                valueStyle={{ color: '#ffc107' }}
                            />
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card>
                            <Statistic
                                title="Vehicle In Poor Condition"
                                value={vInPoor}
                                valueStyle={{ color: '#dc3545' }}
                            />
                        </Card>
                    </Col>
                </Row>
            </PageHeader>
            <Divider />
            <Table
                columns={VehicleColums}
                dataSource={vehicleData}
                rowKey={(record) => record.VehicleID}
                scroll={{ x: 1500, y: 1000 }}
            />
        </>
    )
}

export default Vehicle